import React from "react";
import { useTranslation } from 'react-i18next';
import Logo from "../../../assets/app-only/images/logo.png";

const Brand: React.FC = () => {
  const { t } = useTranslation();

  return (
    <a className="auth-cover-brand d-flex align-items-center gap-2">
      <img
        src={Logo}
        className="app-brand-logo demo"
        alt="CasaCoHost Logo"
        data-app-light-img="assets/app-only/images/logo.png"
        data-app-dark-img="assets/app-only/images/logo.png"
      />
    </a>
  )
};

export default Brand;